import { render, staticRenderFns } from "./PinnedFiltersTemplatesTenders.vue?vue&type=template&id=ceb1d43c&scoped=true"
import script from "./PinnedFiltersTemplatesTenders.vue?vue&type=script&lang=js"
export * from "./PinnedFiltersTemplatesTenders.vue?vue&type=script&lang=js"
import style0 from "./PinnedFiltersTemplatesTenders.vue?vue&type=style&index=0&id=ceb1d43c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb1d43c",
  null
  
)

export default component.exports